import { useTranslation } from 'react-i18next';
import CustomTextInput from 'components/Forms/CustomTextInput';
import { TitleBufferTime } from 'redesign/BusinessTab/BusinessPrepTime/styles';
import { deliveryBufferText, ORDER_BUFFER_TIME } from 'redesign/BusinessTab/BusinessPrepTime/config';
import { FormControlLabel, FormGroup, Grid, MenuItem, Switch } from '@mui/material';

const DeliveryBufferForProvider = ({ prepTimeMethod, handleDeliveryOrderBufferTime }) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12} sx={{ mt: 2, pl: 2 }}>
        <FormGroup>
          <FormControlLabel
            sx={{ width: 'max-content' }}
            control={
              <Switch
                onChange={handleDeliveryOrderBufferTime}
                checked={prepTimeMethod.getValues('orderBufferTime.deliveryOrderBufferTime.enabled')}
              />
            }
            label={t('Enable Delivery order buffer time')}
          />
        </FormGroup>
      </Grid>
      {prepTimeMethod.getValues('orderBufferTime.deliveryOrderBufferTime.enabled') && (
        <Grid item xs={12} sx={{ pl: 2 }}>
          <CustomTextInput
            sx={{ width: '100%', maxWidth: '280px', mt: 2 }}
            select={true}
            name="orderBufferTime.deliveryOrderBufferTime.startTimeMin"
            label={t('First Order buffer time')}
          >
            {ORDER_BUFFER_TIME.map((option) => {
              return (
                <MenuItem key={option.key} value={option.value}>
                  {option.name}
                </MenuItem>
              );
            })}
          </CustomTextInput>
          <CustomTextInput
            sx={{ width: '100%', maxWidth: '280px', mt: 2, ml: 2 }}
            select={true}
            name="orderBufferTime.deliveryOrderBufferTime.endTimeMin"
            label={t('Last Order buffer time')}
          >
            {ORDER_BUFFER_TIME.map((option) => {
              return (
                <MenuItem key={option.key} value={option.value}>
                  {option.name}
                </MenuItem>
              );
            })}
          </CustomTextInput>
        </Grid>
      )}
      <Grid item xs={12} sx={{ mt: 2, pl: 2 }}>
        <TitleBufferTime>{deliveryBufferText}</TitleBufferTime>
      </Grid>
    </>
  );
};

export default DeliveryBufferForProvider;
